// extracted by mini-css-extract-plugin
module.exports = {"cube":"bk_g9","cube__content":"bk_hb","cube_color_white":"bk_hc"};